import { Modal } from "antd";
import classes from "./ActivateModal.module.scss";

export default function ActivateModal({
  open,
  onclose,
  entity,
  active,
  onChangeStatus,
}) {
  const action = active ? "deactivate" : "activate";
  return (
    <Modal
      className={classes.modal}
      open={open}
      onCancel={onclose}
      onOk={onChangeStatus}
      okButtonProps={{
        size: "large",
      }}
      okText={"Yes"}
      cancelButtonProps={{ size: "large" }}
      width={450}
      styles={{
        body: { height: "80px", fontSize: "18px" },
      }}
      centered
    >
      <p>
        {"Are you sure you want to "}
        <span className={active ? classes.inactive : classes.active}>
          {action}
        </span>
        {` this ${entity}?`}
      </p>
    </Modal>
  );
}
